import React, { Component, useEffect, useState } from "react";
import Slider from "react-slick";
import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";
import "./Mainslide.scss";
import axios from "axios";

function Mainslide() {
  const [mainImgData, setMainImgData] = useState([]);
  useEffect(() => {
    getMainImg();
  }, []);
  const getMainImg = async () => {
    const response = await axios.get("/api/main-img");
    setMainImgData(response.data.data);
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <div className="Mainslide" style={{ marginTop: "20px" }}>
      <Slider {...settings}>
        {mainImgData.map((e) => {
          return (
            <div key={e.id} className="Mainslide_list">
              <img alt={e.name} src={`data:image/jpeg;base64,${e.ciImage}`} />
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default Mainslide;
